import { Controller } from '@hotwired/stimulus';
import csrfToken from 'stimulus/csrf_token';

// Remembers that a banner was dismissed, so it stays gone past this page. Pair it with
// Ui::BannerComponent, which owns the dismiss animation and announces when it finishes.
export default class extends Controller {
  static values = { dismissUrl: String };

  dismissed() {
    if (!this.hasDismissUrlValue || !this.dismissUrlValue) return;

    fetch(this.dismissUrlValue, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': csrfToken(),
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).catch(() => {
      // The banner is already gone from this page; the worst case is it returns on the next load.
    });
  }
}
